/**
 * @param {array} rawData Antigo array de perguntas selecionadas. 
 * @returns {array} Lista de dados convertidos para requisição do back
 */

export const getParsedQuestionData = (rawData) => {
  const parsedData = rawData.map(({surveyId, questionId}) => (
    {
      id_pesquisa: surveyId,
      ids_perguntas_principais: [questionId]
    }
  ));
  return parsedData;
}